/**
 * Unified Image Loader
 *
 * Routes all storefront image transforms through Cloudflare.
 */

import { cloudflareImageLoader } from './cloudflareLoader';

export interface ImageLoaderProps {
  aspectRatioHeight?: number;
  aspectRatioWidth?: number;
  background?: string;
  bypassTransform?: boolean;
  fit?: 'contain' | 'cover' | 'crop' | 'pad' | 'scale-down';
  focalPoint?: { x: number; y: number };
  originalImageDimensions?: { x: number; y: number };
  requestWidth?: number;
  src: string;
  /** Automatically trim whitespace around the image */
  trim?: boolean;
  width?: number;
}

/**
 * Unified image loader that always routes through Cloudflare.
 */
export const imageLoader = (props: ImageLoaderProps): string =>
  cloudflareImageLoader(props, 'cloudflare');

/**
 * Creates a Cloudflare image loader for use as a Next.js Image `loader` prop.
 */
export const createImageLoader =
  () =>
  (props: ImageLoaderProps): string =>
    imageLoader(props);
